export type ContentLang = 'fr' | 'en';
export type LocalizedText = Record<ContentLang, string>;

export interface Announcement {
    id: string;                 // stable and unique, "YYYY-MM-DD-slug"
    date: string;               // ISO date "2026-08-28", used for display and sorting
    title: LocalizedText;
    body: LocalizedText;        // plain text, "\n" allowed (rendered as paragraphs)
    expiresAt?: string;         // ISO date; absent = never expires; inclusive
                                // (shown until the end of that day, local time)
    link?: {
        manualSlug?: string;    // slug from articleLoadersByLang, links to /manual
        url?: string;           // or an external URL
    };
}

// Announcements shown in the "What's new" dialog after login. Append new
// entries over time; each one is shown once per user (seen ids are persisted).
export const ANNOUNCEMENTS: Announcement[] = [
    {
        id: "2026-08-28-DIR",
        date: "2026-08-28",
        expiresAt: "2026-09-28",
        title: {
            fr: "Vous pouvez maintenant ranger vos vues dans des répertoires !",
            en: "You can now organize your views into folders!",
        },
        body: {
            fr: "Vous avez maintenant la possibilité de créer des répertoires dans chaque objet pour ranger les vues comme bon vous semble. C'est totalement personnel, vos collaborateurs ne verront pas vos dossiers. Chacun range sa chambre comme il lui plaît !\nComment faire ? Allez sur le menu d'un objet ou sur celui d'un répertoire déjà créé (les 3 points qui apparaissent au survol) et cliquez sur « Nouveau répertoire », puis déplacez vos vues dans ce nouveau répertoire par simple Drag&Drop (cliquer-déposer). Vous pouvez également déplacer un répertoire dans un autre répertoire pour créer une arborescence (limité à 5 niveaux).\nÀ vous de jouer !",
            en: "You can now create folders in each object to organize your views however you like. It's completely personal — your coworkers won't see your folders. Everyone tidies their own room as they please!\nHow does it work? Open the menu of an object or of an existing folder (the 3 dots that appear on hover) and click \"New folder\", then move your views into it with a simple drag and drop. You can also move a folder into another folder to build a hierarchy (up to 5 levels).\nYour turn!",
        },
    },
];
